import { render, staticRenderFns } from "./list-client-staff.vue?vue&type=template&id=10211193&"
import script from "./list-client-staff.vue?vue&type=script&lang=js&"
export * from "./list-client-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports